import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getMyOrgs } from '../api';
import { getActiveOrg, setActiveOrg } from '../org';

const OrgContext = createContext(null);

function pickOrg(orgs, storedId) {
  return orgs.find((o) => o.org_id === storedId)
    || orgs.find((o) => o.default)
    || orgs[0]
    || null;
}

export function OrgProvider({ children }) {
  const [orgs, setOrgs] = useState([]);
  const [active, setActive] = useState(null);
  const [resolved, setResolved] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await getMyOrgs();
      const list = data?.orgs || [];
      const current = pickOrg(list, getActiveOrg());
      if (current) {
        setActiveOrg(current.org_id, current.name, current.role, current.permissions);
      }
      setOrgs(list);
      setActive(current);
    } catch {
      // keep whatever we already resolved
    } finally {
      setResolved(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const switchTo = useCallback((org) => {
    setActiveOrg(org.org_id, org.name, org.role, org.permissions);
    setActive(org);
  }, []);

  const isManager = (active?.permissions || []).includes('tiers.manage');

  return (
    <OrgContext.Provider value={{ orgs, active, resolved, isManager, refresh, switchTo }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error('useOrg must be used inside an OrgProvider');
  return ctx;
}
